<template>
  <div class="aggs">
    <div class="success" v-if="successList&&successList.length>0">
      <div class="success-tip">
        以下产品符合继续申请条件，点击下方页面【立即申请】
      </div>
      <div class="success-list">
        <div class="success-list-item" v-for="(i) in successList" :key="i.orderId" @click="goNext(i)">
          <img class="logo" :src="i.appLogoUrl">
          <div class="mid">
            <div class="title">{{i.productName}}</div>
            <div class="maxAmount">最高额度{{i.maxAmount}}万</div>
            <div class="rate">最低{{ changeRate(i.rateCategory) }}<span v-if="i.rateDesc">({{i.rateDesc}})</span>{{i.rate}}%</div>
          </div>
          <div class="btn">{{i.status=='20004'?'立即申请':i.statusDesc}}</div>
        </div>
      </div>
    </div>

    <div class="fail" v-if="failureList&&failureList.length>0">
      <div class="fail-tip">以下产品初审失败</div>
      <div class="fail-list" v-for="(i) in failureList" :key="i.orderId">
        <div class="fail-list-item">
          <div class="top">
            <img class="logo" :src="i.appLogoUrl">
            <div class="title">{{i.productName}}</div>
          </div>
          <div class="refuseInfo">
            <p v-for="(item,
          index) in i.refuseInfo.split('@')" :key="index">
              {{ index - 0 + 1 }}. {{ item }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      failureList: [],
      successList: [],
      intervalId: null,
    }
  },
  created() {
  },
  mounted() {
    this.getAggsSubOrderList()
    this.refresh()
  },
  computed: {
  },
  beforeDestroy() {
    // 清除 setInterval
    clearInterval(this.intervalId);
  },
  methods: {
    refresh() {
      this.intervalId = setInterval(() => {
        try {
          if (this.successList.length <= 0) {
            clearInterval(this.intervalId);
          } else {
            this.getAggsSubOrderList();
          }
        } catch (error) {
        }
      }, 5000);
    },
    nextStep(orderId) {
      this.$api.CommonForms.nextJumpPageServer({
        orderId
      }).then((res) => {
        if (res.success && res.data) {
          window.location.href = res.data;
        } else {
          Toast(res.returnMessage);
        }
      }).catch((e) => {
        Toast('系统异常，请稍后再试');
      });
    },
    jumpTheThirdPartyAddress(orderId) {
      this.$api.PublicPage.jumpCurrPage({
        orderId,
      })
        .then((res) => {
          if (res.success) {
            if (res.data) {
              window.location.href = res.data;
            }
          } else {
            this.$dialog.alert({
              title: '提示',
              message: '操作失败',
            });
          }
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
    goNext(item) {
      const { orderId, status } = item
      if (status == '20004') {
        this.nextStep(orderId)
      } else if (status < '40003') {
        this.jumpTheThirdPartyAddress(orderId)
      } else {
        this.$router.push('/supermarket/v2/myload?activeIndex=0');
      }
    },
    changeRate(rateValue) {
      if (rateValue === '0') return '日利率';
      if (rateValue === '1') return '月利率';
      if (rateValue === '2') return '年利率';
      return '日利率'; // 当不是这些的时候，就显示日利率
    },
    getAggsSubOrderList() {
      this.$api.PublicPage.getAggsSubOrderList({ aggsOrderId: this.$route.query.orderId })
        .then((res) => {
          if (res.success) {
            const { failureList, successList } = res.data;
            this.failureList = failureList;
            this.successList = successList;
          } else {
            this.$dialog.alert({
              title: '提示',
              message: res.returnMessage,
            });
          }
        })
        .catch((e) => {
          this.$dialog.alert({
            title: '提示',
            message: e,
          });
        });
    },
  },
}
</script>
<style lang="scss" scoped>
.aggs {
  .success {
    &-tip {
      background: #f0fffa;
      padding: 12px 16px;
      font-size: 14px;
      color: #2fccb4;
      line-height: 21px;
      font-weight: 400;
      text-align: left;
    }
    &-list {
      padding: 12px 15px 0 15px;
      &-item {
        display: flex;
        padding: 12px;
        align-items: center;
        background: #ffffff;
        box-shadow: 0 3.5px 11px 2px rgba(206, 206, 206, 0.5);
        border-radius: 6px;
        margin-bottom: 8px;
        .logo {
          width: 64px;
          height: 64px;
          border-radius: 12px;
          border: 1px solid #ececec;
          margin-right: 8px;
        }
        .mid {
          flex: 1;
          .title {
            text-align: left;
            font-size: 17px;
            color: #2f3133;
            line-height: 24px;
            font-weight: 600;
            margin-bottom: 4px;
          }
          .maxAmount,
          .rate {
            text-align: left;
            font-size: 12px;
            color: #767980;
            line-height: 18px;
            font-weight: 400;
          }
          .maxAmount {
            margin-bottom: 1px;
          }
        }
        .btn {
          background: #ff6538;
          border-radius: 15px;
          font-size: 14px;
          color: #ffffff;
          padding: 0 12px;
          line-height: 30px;
          font-weight: 400;
          height: 30px;
          cursor: pointer;
        }
      }
    }
  }
  .fail {
    &-tip {
      padding: 8px 0 12px 0;
      font-size: 14px;
      color: #767980;
      text-align: center;
      line-height: 21px;
      font-weight: 400;
    }
    .result {
      padding: 0 15px;
      height: 44px;
      background: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .left {
        font-size: 14px;
        color: #495060;
        letter-spacing: 0;
        font-weight: 400;
      }
      .right {
        font-size: 16px;
        color: #ff6538;
        text-align: right;
        line-height: 24px;
        font-weight: 400;
        cursor: pointer;
      }
    }
    &-list {
      padding: 0 15px 8px 15px;
      &-item {
        padding: 9px 8px 16px 8px;
        background: #ffffff;
        box-shadow: 0 3.5px 11px 2px rgba(206, 206, 206, 0.5);
        border-radius: 6px;
        .top {
          display: flex;
          margin-bottom: 13px;
          align-items: center;
          .logo {
            margin-right: 5px;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            border: 1px solid #ececec;
          }
          .title {
            font-size: 14px;
            color: #2f3133;
            letter-spacing: 0;
            font-weight: 500;
          }
        }
        .refuseInfo {
          margin-left: 8px;
          font-size: 14px;
          color: #495060;
          letter-spacing: 0;
          font-weight: 400;
          text-align: left;
          p {
            margin: 0 0 2px 0;
          }
        }
      }
    }
  }
}
</style>
